/* eslint-disable jsx-a11y/anchor-is-valid */
import React , { useState }from 'react';
import { ConfigProvider, Button ,message,Upload} from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import axios from 'axios';
import './index.scss'
import zhCN from 'antd/locale/zh_CN';


const login = async () => {
  try {
    const res = await axios.post('http://api_02.ddspp.com:30123/a_device/v2_date_batchs',

      {
        merchant_id: '1000',
        "fu": "test01",
        token: "1000_2ea24c03a81bf5160e93dc39ec7a6a3c",
        psw_md5: 'e10adc3949ba59abbe56e057f20f883e',
        pdate:'2026年10月15日',
        batch_no:"生产编号B",
        code_urls:[
          "http://ddspp.cn/S/18676102100155954512284624814819",
          "http://ddspp.cn/S/18676102100155954612284624897141",
          "http://ddspp.cn/u/?q=18676102100216700712284624713551",
          "http://ddspp.cn/u/?q=18676102100216700812284624716007",
          "http://wasdjpp.cn/u/?q=18676102100216700812284624716007",

        ]
      }
      // , {
      //   headers: {
      //     Authorization: '{"fu":"test01","merchant_id":"1000","token":"1000_2ea24c03a81bf5160e93dc39ec7a6a3c"}'
      //   }
      // }

    );
    console.log(res.data);
  } catch (err) {
    console.error(err);
  }
};







// "{\"fu\":\"test01\",\"merchant_id\":\"1000\",\"token\":\"1000_2ea24c03a81bf5160e93dc39ec7a6a3c\"}"

const Test4 = () => {

const [codeUrls, setCodeUrls] = useState([]);

const beforeUpload = (file) => {
  if (!file.name.endsWith('.txt')) {
    message.error('只能上传 .txt 文件');
    return Upload.LIST_IGNORE;
  }

  const reader = new FileReader();
  reader.readAsText(file, 'UTF-8');

  reader.onload = (e) => {
    const text = e.target.result;

    // 1. 按行 / 逗号 / 空格拆分
    const urls = text
      .split(/[\n,，\s]+/)
      .map(url => url.trim())
      .filter(url => url.length > 0)
      .map(url => {
        // 2. 去掉引号
        url = url.replace(/^["']+|["']+$/g, '');

        // 3. 只保留合法追溯 URL
        if (/^https?:\/\//.test(url)) {
          return url;
        }
        return null;
      })
      .filter(Boolean);

    console.log('解析后的 code_urls：', urls);
    setCodeUrls(urls);
  };

  reader.onerror = () => {
    message.error('文件读取失败');
  };

  return false; // 阻止 antd 自动上传
};

console.log(codeUrls);


  return (<ConfigProvider locale={zhCN} >

    <Button onClick={() => login()}
    >
      aaaaa
    </Button>



    <Upload
        accept=".txt,text/plain"
        showUploadList={false}
        beforeUpload={beforeUpload}
        maxCount={1}
      >
        <Button icon={<UploadOutlined />}>上传 txt 文件</Button>
      </Upload>


     


  </ConfigProvider>

  );
};
export default Test4;